import React from "react";

const AlphaherdNftCard = ({
  animDir,
  animDelay,
  img,
  text,
  nftContent,
  count,
  percent,
  description,
}) => {
  return (
    <div
    //   className="col-md-4"
      data-aos={animDir}
      data-aos-delay={animDelay}
      data-aos-duration="5000"
      data-aos-once="true"
      data-aos-easing="ease-out-cubic"
    >
      <div className="nft_image_box_wrapper">
        {img && (
          <div className="image">
            <img src={img} alt="img" />
          </div>
        )}
        {nftContent && (
          <div className="nft_content">
            {text && <h3>{text}</h3>}
            <div className="nft_top_content">
              <h3>{count}</h3>
              <h2>{percent}</h2>
            </div>
            <div className="nft_bottom">
              <p>{description}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AlphaherdNftCard;
